import {Contract} from "../../../../integration/representation/contract";

export const ListContractSortableField: {[key: string]: string} = {
    name: "Navn",
    referenceId: "Referanse-ID",
    contractor: "Entreprenør",
    county: "Fylke",
    municipality: "Kommune",
    road: "Veg",
    lastModified: "Sist endret",
    completionDate: "Ferdigstilles",
    assigneeDisplayName: "Ansvarlig",
    milestones: "Neste Milepæl",
    status: "Status",
    contractType: "Kontrakttype",
    constructionManager: "Byggeleder",
    rowActions: "",
};

export const notClickableFields = ["rowActions"];

export const sortableFields: SortableField[] = Object.keys(ListContractSortableField).map(key => {
    return {value: key, name: ListContractSortableField[key]};
});

export type SortableField = {
    name: string,
    value: string,
}


